

export const filterTag = (str) => {  
    var x=str.split(/<[^?!m>]+>|\\n/g).filter(x => (x != "")).join("");  
    return x
}